var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7423 6.89897C17.4429 3.44169 14.2717 1 10.5658 1C6.07537 1 2.37002 4.58476 1.82837 9.21739M18.7423 6.89897L20.0002 4.35404M18.7423 6.89897H15.5975M2.25818 13.101C3.55755 16.5583 6.72878 19 10.4347 19C14.9251 19 18.6305 15.4152 19.1721 10.7826M2.25818 13.101L1.00024 15.646M2.25818 13.101H5.403",
    stroke: "#11334E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetZoom);
export default __webpack_public_path__ + "static/media/resetZoom.20c64552838792f8df5790494490cc8e.svg";
export { ForwardRef as ReactComponent };